import React, { useCallback, useEffect } from 'react';

import { connect } from 'react-redux';
import { loginJWTAuth, postLogin } from '../../actions/auth';
import config from '../../config';
import queryString from 'query-string';
import { useHistory } from 'react-router-dom';

const actionCreators = {
  postLogin,
};
const TokenHandler = ({ postLogin, history: { replace }, location: { search } }) => {
  const history = useHistory();
  const urlParams = new URLSearchParams(search);
  const token = urlParams.get('token');
  const redirectFunction = useCallback(() => {
    const { redirect: redirectUrl } = queryString.parse(search);
    replace(redirectUrl || config.BASE_ROUTE);
  }, [replace, search]);

  useEffect(() => {
    if (token) {
      const userInfo = loginJWTAuth(token);
      postLogin(userInfo, redirectFunction);
    }
  }, [postLogin, history, redirectFunction, token]);

  return (
    <div>
      <h1>Token Handler</h1>
    </div>
  );
};

// Connect the TokenHandler component to the Redux store
export default connect(null, actionCreators)(TokenHandler);
